import React from 'react';
import styled from 'styled-components';

export default styled(props => (
  <svg id="clock" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 97 97" {...props}>
    <circle className="clock-back" cx="48.5" cy="48.5" r="48.5" />
    <rect className="minute hand" x="44" y="9" width="8" height="42" />
    <rect className="hour hand" x="44" y="44" width="25" height="8" />
  </svg>
))`
  position: relative;
  height: 50px;

  .clock-back {
    fill: #86e2b1;
  }

  .hand {
    fill: #fff;
  }

  .minute-hand {
    fill: #fff;
  }
`;
